import $i18n from 'panda-i18n';
import React from 'react';
import { Select, Form, Field, DatePicker } from '@fpxfd/next';
import { useSetState } from 'ahooks';
import styles from './index.module.scss';
import { SelectProps } from '@fpxfd/next/types/select';
import { RangePickerProps } from '@fpxfd/next/types/date-picker';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

interface SearchTimeProps {
  selectProps: SelectProps;
  rangePickerProps?: RangePickerProps;
  label?: string | React.ReactNode;
  callback?: (object) => void;
}

const SearchSelect = ({ selectProps, rangePickerProps, callback, label }: SearchTimeProps) => {
  const [selectval, setselectval] = useSetState({
    selects: selectProps?.defaultValue || '',
    time: rangePickerProps?.defaultValue || [],
    name: selectProps?.defaultValue || '',
  });

  const getvals = (val, type) => {
    const data = { ...selectval };
    if (type === 'selects') {
      data.selects = val;
      data.name = val;
    } else {
      data.time = val;
    }
    setselectval(data);
    callback && callback(data);
  };
  // 时间转换
  const setTime = (value) => {
    const time: any = [];
    if (value.length) {
      value.forEach((e, i) => {
        i === 0 && time.push(e);
        i === 1 && time.push(e);
      });
    }
    getvals(time, 2);
  };
  return (
    <FormItem label={label || $i18n.get({ id: 'Time.four_px', dm: '时间' })}>
      <div className={styles.timedown}>
        <FormItem>
          <Select
            {...selectProps}
            onChange={(value: any, actionType: string, item: any) => {
              getvals(value, 'selects');
              selectProps.onChange && selectProps.onChange(value, actionType, item);
            }}
          />
        </FormItem>
        <FormItem style={{ width: '100%' }}>
          <RangePicker {...rangePickerProps} onChange={setTime} />
        </FormItem>
      </div>
    </FormItem>
  );
};

export default SearchSelect;
